module.exports = __webpack_public_path__ + "img/sort.4d10e882.svg";